import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5dcd7370"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "audience-composition-skeleton" };
const _hoisted_2 = { class: "audience-composition-skeleton__header" };
const _hoisted_3 = { class: "audience-composition-skeleton__group" };
const _hoisted_4 = { class: "mb-2" };
const _hoisted_5 = { class: "audience-composition-skeleton__form" };
const _hoisted_6 = { class: "audience-composition-skeleton__divisor" };
import SkeletonLoader from '@/components/_atoms/SkeletonLoader.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceCompositionSkeleton',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(SkeletonLoader, {
                        height: "20px",
                        width: "219px"
                    })
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(SkeletonLoader, {
                            height: "14px",
                            width: "114px"
                        })
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(SkeletonLoader, { width: "400px" }),
                        _createVNode(SkeletonLoader, { width: "217px" }),
                        _createVNode(SkeletonLoader, { width: "217px" }),
                        _createVNode(SkeletonLoader, { width: "174px" })
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createVNode(SkeletonLoader, { width: "166px" })
                ]),
                _createVNode(SkeletonLoader, {
                    height: "20px",
                    width: "136px",
                    class: "audience-composition-skeleton__footer"
                }),
                _createVNode(SkeletonLoader, { width: "166px" })
            ]));
        };
    }
});
